import { 
    apiRequest,
    perjalananDinasList,
    perjalananDinasInactive,
    EmployeeDetail
} from '../../../../../../services/adapters/kepegawaian/perjalananDinasService'

class IndexRepository {

    fetchEmployeeDetail = async (query, cancelToken) => {
        return await apiRequest("get", EmployeeDetail, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", perjalananDinasList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", perjalananDinasInactive, {
            body: query
        }, true)
    }

}

export default IndexRepository